var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"d-flex align-items-baseline"},[_c('b-spinner',{attrs:{"small":"","label":"Checking account"}}),_c('h4',{staticClass:"ml-2"},[_vm._v("Checking account..")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }